import { memo } from 'react';
import PlayerTimelineButton from './PlayerTimelineButton';
import useAddChapterItem from '../hooks/useAddChapterItem';

const AddChapter = () => {
  const chapterItem = useAddChapterItem();

  // Don't render if chapters are not supported for this clip
  if (!chapterItem) {
    return null;
  }

  return (
    <PlayerTimelineButton
      tooltipTitle={chapterItem.label}
      buttonId="new-timeline-add-chapter-button"
      onClick={chapterItem.onClick}
      iconName={chapterItem.iconName}
      isLoading={chapterItem.label.includes('Adding')}
      isDisabled={chapterItem.isDisabled}
    />
  );
};

export default memo(AddChapter);
